import * as React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import SidePrice from "./side-price";
import { pick } from "../../model/utils";

const TotalPrice = ({ experiencePrice, roomPrice, hidePriceInLowRes }) =>
  (!!experiencePrice || !!roomPrice) && (
    <SidePrice
      price={getPrice(experiencePrice) + getPrice(roomPrice)}
      extraContainerStyleName="large"
      hidePriceInLowRes={hidePriceInLowRes}
    />
  );

TotalPrice.propTypes = {
  experiencePrice: PropTypes.number,
  roomPrice: PropTypes.number,
  hidePriceInLowRes: PropTypes.bool
};

const getPrice = price => (!price ? 0 : price);

export default connect(pick(["experiencePrice", "roomPrice"]))(TotalPrice);
